<template>
    <div>
        <v-form ref="formLanguageWaiver" class="formLanguageWaiver">
            <p class="text-left text-h6">
                {{ $t("page.createWaiver.waiver_logo") }}
            </p>
            <p class="text-left mt-4">
                {{ $t("page.createWaiver.description_logo") }}
            </p>
            <v-row>
                <v-col md="3" sm="6" cols="12">
                    <v-img
                        width="100%"
                        :src="imageUrl"
                        v-on:error="ImgError"
                        style="max-height: 280px"
                    ></v-img>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-btn
                        class="my-4 float-left"
                        outlined
                        @click="upload(language)"
                    >
                        {{ $t("page.createWaiver.change_your_image") }}
                    </v-btn>
                    <v-btn
                        class="my-4 float-left ml-1"
                        outlined
                        @click="showDeleteImageDialog = true"
                    >
                        {{ $t("page.createWaiver.remove_image") }}
                    </v-btn>
                    <input
                        style="display: none"
                        type="file"
                        :id="`uploadImage_${language}`"
                        name="uploadImage_[]"
                        accept="image/*"
                        @change="onImageChange($event, language)"
                        multiple
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="10" md="6">
                    <v-text-field
                        :label="$t('page.createWaiver.waiver_title')"
                        v-model="waiverTitle"
                        outlined
                        dense
                        :hint="$t('page.createWaiver.description_waiver_title')"
                        persistent-hint
                        :rules="waiverTitleRules"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12"> </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <h5 class="text-left">
                        {{ $t("page.createWaiver.waiver") }}
                        <p class="mt-2">
                            {{
                                $t("page.createWaiver.parameters_waiver_note_1")
                            }}
                            <br />
                            {{
                                $t("page.createWaiver.parameters_waiver_note_2")
                            }}
                            <br />
                            {{
                                $t("page.createWaiver.parameters_waiver_note_3")
                            }}
                            <br />
                            {{
                                $t("page.createWaiver.parameters_waiver_note_4")
                            }}
                            <br />
                        </p>
                    </h5>
                    <ckeditor
                        ref="ckeditorWaiver"
                        :editor="editor"
                        v-model="waiver"
                        :config="editorConfig"
                        @ready="onEditorWaiver"
                    ></ckeditor>
                    <span
                        v-if="hasErrorWaiverRequired"
                        class="text-caption float-left error--text"
                        >{{ $t("page.createWaiver.waiver_required") }}</span
                    >
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <h5 class="text-left">
                        {{
                            $t("page.createWaiver.electronic_signature_consent")
                        }}
                    </h5>

                    <ckeditor
                        ref="ckeditorElectronicSignature"
                        :editor="editor"
                        v-model="electronicSignature"
                        :config="editorConfig"
                        @ready="onEditorElectronicSignature"
                    ></ckeditor>
                    <span
                        v-if="hasErrorElectronicSignatureRequired"
                        class="text-caption float-left error--text"
                        >{{
                            $t(
                                "page.createWaiver.electronic_signature_required"
                            )
                        }}</span
                    >
                </v-col>
            </v-row>
        </v-form>
        <v-dialog v-model="showDeleteImageDialog" max-width="400">
            <v-card>
                <v-card-title class="text-h5 pb-2">
                    {{ $t("page.createWaiver.delete_image") }}
                </v-card-title>

                <v-card-text class="pt-3 pb-0 text-left">
                    {{ $t("page.createWaiver.delete_image_confirmation") }}
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        class="mr-2"
                        @click="showDeleteImageDialog = false"
                    >
                        {{ $t("common.cancel") }}
                    </v-btn>
                    <v-btn color="error" @click="removeImage" elevation="0">
                        {{ $t("common.delete") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
//import DecoupledEditor from '@ckeditor/ckeditor5-editor-decoupled';
import DecoupledDocumentEditor from "@ckeditor/ckeditor5-build-decoupled-document";

import { apiCalls } from "@/mixins/apiCalls.js";

export default {
    name: "FormWaiver",
    mixins: [apiCalls],
    props: {
        language: { type: String, default: "en" },
        bandEditParent: { type: Boolean, default: false },
    },
    data() {
        return {
            buttonColor: "#000",
            uploadImage_: null,
            fileName: "",
            waiverTitle: "",
            waiver: "",
            editor: DecoupledDocumentEditor,
            editorConfig: {},
            editorDisabled: false,
            electronicSignature: "<p>The Participant acknowledges that they have read and understand this Agreement, that they have executed this Agreement voluntarily, and that this Agreement is to be binding upon themselves, their heirs, spouse, children, parents, guardians, next of kin, executors, administrators and legal or personal representatives. They further acknowledge that by signing this Agreement they have waived their right to maintain a lawsuit against the Organization on the basis of any claims from which they have released herein.</p>",
            reader: null,
            bandReader: false,
            file: null,
            imageUrl: null,
            hasErrorWaiverRequired: false,
            hasErrorElectronicSignatureRequired: false,
            bandEdit: false,
            waiverAux: "",
            electronicSignatureAux: "",
            isReadyWaiver: false,
            isReadyElectronicSignature: false,
            bandEditWaiver: false,
            bandEditElectronicSignature: false,
            showDeleteImageDialog: false,
        };
    },
    methods: {
        ImgError() {
            this.imageUrl = require("@/assets/images/orgPlaceholder.jpg.png");
        },
        upload(language) {
            document.getElementById(`uploadImage_${language}`).click();
        },
        async onImageChange(e, languageCode) {
            this.$emit("onImageChange", languageCode);
            this.uploadImage_ = e.target.files[0];
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            if (!files[0].type.includes("image/")) {
                this.$emit(
                    "showSnackBar",
                    this.$t("page.createWaiver.logo_format_invalid")
                );
            }
            this.createImage(files[0], languageCode);
            this.fileName = files[0].name;
        },
        createImage(file) {
            this.reader = new FileReader();
            this.reader.onload = () => {
                this.imageUrl = this.reader.result;
            };
            this.reader.readAsDataURL(file);
        },
        removeImage() {
            this.uploadImage_ = null;
            this.fileName = "";
            this.imageUrl = null;
            this.ImgError();
            this.showDeleteImageDialog = false;
            this.$emit("onImageChange", this.language);
        },
        verifyValidation() {
            if ((this.waiver || "").length == 0)
                this.hasErrorWaiverRequired = true;
            if ((this.electronicSignature || "").length == 0)
                this.hasErrorElectronicSignatureRequired = true;
            if (
                !this.$refs.formLanguageWaiver.validate() ||
                this.hasErrorWaiverRequired ||
                this.hasErrorElectronicSignatureRequired
            ) {
                return false;
            }
            return true;
        },
        onEditorWaiver(editor) {
            editor.ui
                .getEditableElement()
                .parentElement.insertBefore(
                    editor.ui.view.toolbar.element,
                    editor.ui.getEditableElement()
                );
            this.isReadyWaiver = true;
            if (this.bandEditParent && !this.bandEditWaiver) {
                this.waiver = this.waiverAux;
                this.bandEditWaiver = true;
            }
        },
        onEditorElectronicSignature(editor) {
            editor.ui
                .getEditableElement()
                .parentElement.insertBefore(
                    editor.ui.view.toolbar.element,
                    editor.ui.getEditableElement()
                );
            this.isReadyElectronicSignature = true;
            if (this.bandEditParent && !this.bandEditElectronicSignature) {
                this.electronicSignature = this.electronicSignatureAux;
                this.bandEditElectronicSignature = true;
            }
        },
        loadData(waiverTraslate) {
            if (!this.bandEdit) {
                this.bandEdit = true;
                this.imageUrl =
                    this.VUE_APP_DOMAIN + waiverTraslate.headerLogoUrl;
                this.waiverTitle = waiverTraslate.title;
                if (this.isReadyWaiver) {
                    this.waiver = waiverTraslate.waiverText;
                    this.bandEditWaiver = true;
                } else this.waiverAux = waiverTraslate.waiverText;
                if (this.isReadyElectronicSignature) {
                    this.electronicSignature =
                        waiverTraslate.waiverElectronicConsent;
                    this.bandEditElectronicSignature = true;
                } else
                    this.electronicSignatureAux =
                        waiverTraslate.waiverElectronicConsent;
            }
        },
        onLoad() {
            this.$emit("loadDataParent", this.language);
        },
    },
    computed: {
        waiverTitleRules() {
            return [
                (val) =>
                    (val || "").length > 0 ||
                    this.$t("page.createWaiver.waiver_title_required"),
            ];
        },
        VUE_APP_DOMAIN: () => process.env.VUE_APP_ROOT,
    },
    created: function () {
        this.buttonColor = process.env.VUE_APP_BUTTON_COLOR;
        this.imageUrl = require("@/assets/images/orgPlaceholder.jpg.png");
    },
    mounted() {
        if (this.bandEditParent) this.onLoad();
    },
    watch: {
        waiver(val) {
            if ((val || "").length == 0) {
                this.hasErrorWaiverRequired = true;
            } else {
                this.hasErrorWaiverRequired = false;
            }
        },
        electronicSignature(val) {
            if ((val || "").length == 0) {
                this.hasErrorElectronicSignatureRequired = true;
            } else {
                this.hasErrorElectronicSignatureRequired = false;
            }
        },
    },
};
</script>

<style scss>
.formLanguageWaiver .ck.ck-toolbar {
    border-radius: 2px 2px 0px 0px;
}
.formLanguageWaiver .ck.ck-content {
    border-left: 1px solid #c4c4c4;
    border-right: 1px solid #c4c4c4;
    border-bottom: 1px solid #c4c4c4;
    margin-top: -1px;
}
</style>
